import React from 'react';

import {
  isDesktopDevice,
  offerVariantsList,
  prepareOfferUniqueKey
} from '../../services/services';
import Loader from './loader';
import Offer from './offer-list-element';
import Table from './responsive-table';
import NoOffersContactForm from './no-offers-contact-form';
import { T } from '../../../../common/locale/translate';
import { uuid } from '../../services/uuid';

export default class OfferVariants extends React.Component {
  constructor() {
    super();
    this.state = {
      A: { headers: 'withFlight', className: 'with-flight' },
      S: { headers: 'withoutFlight', className: 'without-flight' },
      withFlight: [
        { name: 'flight', title: T('departure_place') },
        { name: 'departure', title: T('travel_departure') },
        { name: 'arrival', title: T('travel_arrival') },
        { name: 'duration', title: T('admin_special_offers_duration') },
        { name: 'provider', title: T('operator') },
        { name: 'alimentation', title: T('board') },
        { name: 'accommodation', title: T('accommodation') },
        { name: 'price', title: T('price_quality') }
      ],
      mobile_withFlight: [
        { name: 'mobile-price', title: '' },
        { name: 'flight', title: T('departure_place') },
        { name: 'duration', title: T('admin_special_offers_duration') },
        { name: 'alimentation', title: T('board') },
        { name: 'provider', title: T('operator') },
        { name: 'accommodation', title: T('accommodation') },
        { name: 'mobile-choose-button', title: '' }
      ],
      withoutFlight: [
        { name: 'departure', title: T('travel_departure') },
        { name: 'arrival', title: T('travel_arrival') },
        { name: 'duration', title: T('admin_special_offers_duration') },
        { name: 'provider', title: T('operator') },
        { name: 'alimentation', title: T('board') },
        { name: 'accommodation', title: T('accommodation') },
        { name: 'price', title: T('price_quality') }
      ],
      mobile_withoutFlight: [
        { name: 'mobile-price', title: '' },
        { name: 'duration', title: T('admin_special_offers_duration') },
        { name: 'provider', title: T('operator') },
        { name: 'alimentation', title: T('board') },
        { name: 'accommodation', title: T('accommodation') },
        { name: 'mobile-choose-button', title: '' }
      ],
      loader: true,
      loadMoreText: T('more_dates'),
      current_state: 'pristine',
      current_page: 0,
      is_last_page: false,
      OFFERS_LIST_LIMIT: 10,
      MAX_AUTO_REQUEST_NUMBER: 3,
      AUTO_REQUEST_NUMBER: 0,
      PENDING_REQUESTS_IDS: [],
      MIN_AVAILABLE_OFFERS_NUMBER: 5,
      AVAILABLE_OFFERS_NUMBER: 0,
      data: [],
      params: {},
      lowestPrice: null
    };
  }

  render = () => {
    const { offer_type, active, price, loaderText } = this.props;
    const {
      loader,
      lowestPrice,
      current_state,
      is_last_page,
      params,
      data,
      loadMoreText
    } = this.state;
    const isMobile = `${!isDesktopDevice() ? 'mobile_' : ''}`;
    const option = this.state[offer_type];
    const className = `${isMobile}${option.className}`;
    const headers = `${isMobile}${option.headers}`;

    return (
      <section
        className={`offer-variants ${className} ${
          active ? 'active' : 'inactive'
        }`}
        ref={() => {
          this.appendOfferVariants = this.appendOfferVariants;
        }}
      >
        <Table headers={this.state[headers]}>
          {data.map((offer, i) => {
            const tableRowKey = `${prepareOfferUniqueKey(offer)}-${i}`;
            return (
              <Offer
                key={tableRowKey}
                tableRowKey={tableRowKey}
                data={offer}
                checkAvailability
                params={params}
                price={price}
                lowestPrice={lowestPrice}
                updateOfferPrice={this.updateOfferPrice}
                updateTheLowestPrice={this.updateTheLowestPrice}
                updatePendingRequestCounter={this.updatePendingRequestCounter}
                reloadOnPropsData
              />
            );
          })}
        </Table>
        <Loader
          active={loader}
          className="offer-variants-loader"
          text={loaderText}
        />
        {(is_last_page || current_state === 'error') && (
          <NoOffersContactForm
            className="no-more-offers-contact-form"
            header={T('no_more_offers_contact_form_header')}
            sendButtonText={T('send')}
            isOfferVariantsForm
          />
        )}
        <div
          className={`action-wrapper ${current_state} ${
            is_last_page ? 'last-page' : ''
          }`}
        >
          <a
            rel="nofollow"
            href="javascript:void(0)"
            className="terms-and-prices"
            title={loadMoreText}
            onClick={this.appendOfferVariants.bind(this, params, false)}
          >
            {' '}
            {loadMoreText} <i className="fa fa-chevron-down" />{' '}
          </a>
        </div>
      </section>
    );
  };

  appendOfferVariants = (params, reload = false) => {
    const { current_state, current_page, data, OFFERS_LIST_LIMIT } = this.state;
    params.limit = OFFERS_LIST_LIMIT;

    if (current_state !== 'error' || reload) {
      this.setState({
        loader: true,
        params,
        current_state: 'in-progress',
        data: reload ? [] : data,
        current_page: reload ? 0 : current_page
      });
      params.page = reload ? 0 : current_page;
      offerVariantsList(params).then(
        response => {
          if (response.status == 204) {
            this.setState({
              loader: false,
              loadMoreText: T('no_available_offers'),
              current_state: 'error'
            });
          } else {
            const offersList = this.normalizeOffersList(response);
            this.setState({
              loader: false,
              data: reload ? offersList : data.concat(offersList),
              current_page: current_page + 1,
              current_state: 'done',
              is_last_page: response.data.is_last_page
            });
          }
        },
        error => {
          console.log(`Error occured, failure message: ${error}`);
        }
      );
    }
  };

  updateTheLowestPrice = price => {
    const currentLowestPrice = this.state.lowestPrice;
    this.setState({
      lowestPrice:
        !currentLowestPrice || price < currentLowestPrice
          ? price
          : currentLowestPrice
    });
  };

  updateOfferPrice = offer => {
    const offersList = this.state.data.map(
      el => (el.uuid === offer.uuid ? { ...offer } : { ...el })
    );
    const sorted = offersList.sort((a, b) => {
      return a.price_pln - b.price_pln;
    });

    this.setState({
      data: [...sorted],
      AVAILABLE_OFFERS_NUMBER: ++this.state.AVAILABLE_OFFERS_NUMBER
    });
  };

  normalizeOffersList = response => {
    const offers_list = response.data.offers_list || [];
    return offers_list.map(offer => ({
      uuid: uuid(),
      ...offer
    }));
  };

  updatePendingRequestCounter = (uuid, action) => {
    const {
      PENDING_REQUESTS_IDS,
      AUTO_REQUEST_NUMBER,
      MAX_AUTO_REQUEST_NUMBER,
      AVAILABLE_OFFERS_NUMBER,
      MIN_AVAILABLE_OFFERS_NUMBER,
      is_last_page
    } = this.state;

    //component state is mutated on purpose here
    switch (action) {
      case 'ADD':
        PENDING_REQUESTS_IDS.push(uuid);
        break;
      case 'REMOVE':
        PENDING_REQUESTS_IDS.splice(PENDING_REQUESTS_IDS.indexOf(uuid), 1);
        break;
    }

    if (
      AUTO_REQUEST_NUMBER < MAX_AUTO_REQUEST_NUMBER &&
      PENDING_REQUESTS_IDS.length === 0 &&
      AVAILABLE_OFFERS_NUMBER < MIN_AVAILABLE_OFFERS_NUMBER &&
      !is_last_page
    ) {
      this.appendOfferVariants(this.state.params);
      this.setState({ AUTO_REQUEST_NUMBER: ++this.state.AUTO_REQUEST_NUMBER });
    }

    if (
      AUTO_REQUEST_NUMBER === MAX_AUTO_REQUEST_NUMBER &&
      PENDING_REQUESTS_IDS.length === 0
    ) {
      this.setState({
        loader: false,
        loadMoreText: T('no_available_offers'),
        current_state: 'error'
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/offer-variants.js